import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AssembleaView } from 'src/app/model/assemblea-view';
import { AttachmentsService } from 'src/app/services/attachments/attachments.service';

@Component({
  selector: 'app-decreti-approvazione',
  templateUrl: './decreti-approvazione.component.html',
  styleUrls: ['./decreti-approvazione.component.scss']
})
export class DecretiApprovazioneComponent implements OnInit, AfterViewInit {
  constructor(private attachmentsService: AttachmentsService) {
    this.dataSource = new MatTableDataSource();
  }

  dataSource: MatTableDataSource<AssembleaView>;
  displayedColumns: string[] = [
    "dataDecreto",
    "nomeDecreto",
    "azioni",
  ];
  totalItems: number = 0;
  pageSize: number = 10; // Imposta la dimensione della pagina iniziale
  pageSizeOptions: number[] = [5, 10, 25, 100]; // Opzioni di dimensione pagina
  pageIndex = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  currentPage: number;

  public ngAfterViewInit(): void {
    this.currentPage = 0;
    this.pageSize = 10;
    this.dataSource.sort = this.sort;
  }

  public onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.loadDatatable();
  }

  ngOnInit(): void {
    this.loadDatatable();
  }

  loadDatatable() {

    this.attachmentsService.ricercaDecreti(this.pageIndex, this.pageSize).subscribe({
      next: (response: any) => {
        this.totalItems = response.result.count;
        this.dataSource = new MatTableDataSource(response.result.listaAssemblea);
        this.dataSource.sort = this.sort;
      }
    })
  }

  sortData(sort: any) {
    if (sort.active && sort.direction !== '') {
      this.dataSource.data.sort((a: any, b: any) => {
        let comparison = 0;
        if(sort.active.includes('data')){
          const fieldSplitted = sort.active.split('_');
          const field = `${fieldSplitted[0]}${fieldSplitted[1].charAt(0).toUpperCase()}${fieldSplitted[1].slice(1)}`;
          const firstValue = new Date(a[field]);
          const secondValue = new Date(b[field]);
          comparison = firstValue > secondValue ? 1 : -1;
        }else{
          comparison = a > b ? 1 : -1;
        }
        return sort.direction === 'asc' ? comparison : -comparison;
      });
    }
  }

  downloadDecreto(id: any) {
    let data = {
      valore: id
    }
    this.attachmentsService.downloadDocumentoHomePage(data).subscribe(
      (data: any) => {
        let fileName: string = "Decreto.pdf";
        this.attachmentsService.downloadService(data, fileName);
      }
    )
  }

  onPaginateChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.loadDatatable();
  }

}
